import React, { useState } from "react";
import { useNavigate,useHistory  } from "react-router-dom";
import { generatePath } from "react-router";
import {apiUrl, domainUrl} from '../constant';
import {authtoken} from '../global.js';
import {authHeader,authToken} from '../helpers/auth-header';
import axios from 'axios';
const axios1 = require("axios");
export const timesheetreportService = {
    showreportgettimesheet,
    getemployeelist,
    getclientslist,
    rdsshow_report,
    getmangrlist,
    gettimesheeforapproval,
    rdsshow_report_toappr,
    showreportexport,
    productivityreports,
    getfinalbillascategoriesmulti,
    getfinalbillascategories,
    getfinalconfig,
    getuserfinalbill,
    bkfinalbillreport,
    bkfinalbillreportexport,
    showrptexporttoexcel,
    get_user_details,
    get_total_target_hours,
    import_excelfile,
    getbillinfo,
    getfinalbillapproval,
    deleteassign,
    getclientslistmanager,
    getbillinfoexport,
    getmultitimesheeforapproval,
    deleterds,
    showreportanalysis,
    export_rds_report
};

function showreportgettimesheet({formdataobj,pageno}){
    let clientid = formdataobj.clientid;
    let employeeid = formdataobj.employeeid;
    let frmdt = formdataobj.frmdt;
    let todt = formdataobj.todt;
    let subclientid = formdataobj.subclientid;
    let _pageno = pageno;
   
    // POST body (not query string) so names containing & or ' are sent intact
    return axios({
        method: "post",
        url: `${apiUrl}/api/showreportgettimesheet`,
        data: {
            clientid: clientid,
            employeeid: employeeid,
            frmdt: frmdt,
            todt: todt,
            subclientid: subclientid,
            page: _pageno
        },
        headers: {Authorization: `Bearer ${authToken()}` },
      })
        .then(function (response) {
           if(response.status == 200){
                    
          }
          return response;
        }, error => {
          return error.response;
          // console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}

function getbillinfo({formdataobj,pageno}){
  let clientid = formdataobj.clientid;
  let employeeid = formdataobj.employeeid;
  let frmdt = formdataobj.frmdt;
  let todt = formdataobj.todt;
  let subclientid = formdataobj.subclientid;
  let _pageno = pageno;
 
  return axios({
      method: "get",
      url: `${apiUrl}/api/getbillinfo?clientid=${clientid}&&employeeid=${employeeid}&&frmdt=${frmdt}&&todt=${todt}&&subclientid=${subclientid}&&page=${_pageno}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function showrptexporttoexcel({formdataobj}){
  let clientid = formdataobj.clientid;
  let employeeid = formdataobj.employeeid;
  let frmdt = formdataobj.frmdt;
  let todt = formdataobj.todt;
  let subclientid = formdataobj.subclientid;
  
  return axios({
      method: "get",
      url: `${apiUrl}/api/showrptexporttoexcel?clientid=${clientid}&&employeeid=${employeeid}&&frmdt=${frmdt}&&todt=${todt}&&subclientid=${subclientid}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });    
}

function showreportexport({formdataobj}){
  let clientid = formdataobj.clientid;
  let employeeid = formdataobj.user_id;
  let frmdt = formdataobj.fromdate;
  let todt = formdataobj.todate;
  let subclientid = formdataobj.subclient;
  
  return axios({
      method: "get",
      url: `${apiUrl}/api/showrptexporttoexcel?clientid=${clientid}&&employeeid=${employeeid}&&frmdt=${frmdt}&&todt=${todt}&&subclientid=${subclientid}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });    
}


function getemployeelist({managerid, accesstype}){
    let url = `${apiUrl}/api/getemployeelist?managerid=${managerid}`;
    if(accesstype != undefined && accesstype != ''){
        url += `&accesstype=${accesstype}`;
    }
    return axios({
        method: "get",
        url: url,
        // data: requestQuery,
        headers: {Authorization: `Bearer ${authToken()}` },
      })
        .then(function (response) {
           if(response.status == 200){
                    
          }
          return response;
        }, error => {
          return error.response;
          // console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });  
}

function getclientslist(){
    return axios({
        method: "get",
        url: `${apiUrl}/api/getclientslist`,
        // data: requestQuery,
        headers: {Authorization: `Bearer ${authToken()}` },
      })
        .then(function (response) {
           if(response.status == 200){
                     
          }
          return response;
        }, error => {
          return error.response;
          // console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });   
}

function getclientslistmanager(manager_id, { projectid } = {}){
  return axios({
      method: "get",
      url: `${apiUrl}/api/getclientslist?managerid=${manager_id}&projectid=${projectid}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                   
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });   
}

function rdsshow_report({obj}){
  let emp_id= obj.emp_id;
  let fromdate = obj.fromdate;
  let todate = obj.todate; 
  let manager_id = obj.manager_id ?? 288; 
  return axios({
    method: "get",
    url: `${apiUrl}/api/rdsshow_report?emp_id=${emp_id}&fromdate=${fromdate}&todate=${todate}&manager_id=${manager_id}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });      
} 


function export_rds_report({obj}){
  let emp_id= obj.emp_id;
  let fromdate = obj.fromdate;
  let todate = obj.todate; 
  let manager_id = obj.manager_id ?? 288; 
  return axios({
    method: "get",
    url: `${apiUrl}/api/export_rds_report?emp_id=${emp_id}&fromdate=${fromdate}&todate=${todate}&manager_id=${manager_id}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });      
} 

function rdsshow_report_toappr({obj}){
  let emp_id= obj.userid;
  let date= obj.date;
  // let fromdate = obj.fromdate;
  // let todate = obj.todate; 
  // let manager_id = obj.manager_id = 288; 
  return axios({
    method: "get",
    url: `${apiUrl}/api/rdsshow_report_toappr?emp_id=${emp_id}&smonth=10&syear=2023&date=${date}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}

function getmangrlist(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getmangrlist`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });      
}

function getmultitimesheeforapproval({obj}){
  let tsdate = obj.date;
  let userid = obj.userid; 
 
  return axios({
    method: "get",
    url: `${apiUrl}/api/getmultitimesheeforapproval?tsdate=${tsdate}&&userid=${userid}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function gettimesheeforapproval({obj}){
  let tsdate = obj.date;
  let userid = obj.userid; 
 
  return axios({
    method: "get",
    url: `${apiUrl}/api/gettimesheeforapproval?tsdate=${tsdate}&&userid=${userid}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function productivityreports({obj}){
let clientid= obj.clientid;
let employeeid = obj.employeeid;
let frmdt = obj.frmdt;
let todt = obj.todt;
let subclientid = obj.subclientid;

let requestQuery = {
  'clientid':clientid,
  'subclientid':subclientid,
  'employeeid':employeeid,
  'frmdt':frmdt,
  'todt':todt 
};

  return axios({
    method: "post",
    url: `${apiUrl}/api/budgetshowreportgettimesheet`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });  
}

function getfinalbillascategoriesmulti({obj}){
  let fromdate = obj.fromdate;
  let manager_id = obj.manager_id;
  let client = obj.client;
  let categories = obj.categories;
  
  let objdata = {
    'client':client,
    'categories':categories,
     'manager_id':manager_id,
     'fromdate':fromdate,
     
  };
  return axios({
    method: "post",
    url: `${apiUrl}/api/getfinalbillascategoriesmulti`,
    data: objdata,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getfinalbillascategories({obj}){
  let fromdate = obj.fromdate;
  let manager_id = obj.manager_id;
  let client = obj.client;
  let categories = obj.categories;
  let selectedteam = obj.selectedteam;
  let dept = obj.dept;
  return axios({
    method: "get",
    url: `${apiUrl}/api/getfinalbillascategories?selectedteam=${selectedteam}&client=${client}&categories=${categories}&manager_id=${manager_id}&fromdate=${fromdate}&dept=${dept}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}


function getfinalconfig({obj}){
  
  return axios({
    method: "get",
    url: `${apiUrl}/api/getfinalbill?fromdate=${obj.fromdate}&manager_id=${obj.managerid}&clientid=${obj.client_id}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function getuserfinalbill({obj}){
  // console.log(obj); 
  // console.log("object data");
  return axios({
    method: "get",
    url: `${apiUrl}/api/__getuserfinalbill?fromdate=${obj.fromdate}&client_id=${obj.client_id}&managerid=${obj.managerid}&subclient=${obj.subclient}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function bkfinalbillreport({obj,fromdate,page}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/bkfinalbillreport?fromdate=${obj.fromdate}&todate=${obj.todate}&clientid=${obj.clientid}&user_id=${obj.user_id}&subclient=${obj.subclient}&page=${page}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function bkfinalbillreportexport({obj,fromdate}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/bkfinalbillreportexport?fromdate=${obj.fromdate}&todate=${obj.todate}&clientid=${obj.clientid}&user_id=${obj.user_id}&subclient=${obj.subclient}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function get_user_details({manager_id}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/get_user_details?mangerid=${manager_id}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function get_total_target_hours(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/get_total_target_hours`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                 
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function import_excelfile({file}){
  let requestQuery = file;
  return axios({
    method: "post",
    url: `${apiUrl}/api/import_excelfile`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        console.log("response");
        console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getfinalbillapproval({formdata}){ 
  let requestQuery = JSON.parse(formdata);
  return axios({
    method: "post",
    url: `${apiUrl}/api/getfinalbillapproval`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}

function deleteassign(formdata){
    // console.log(id); 
    let requestQuery = formdata;
  return axios({
    method: "post",
    url: `${apiUrl}/api/deleteassign`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}

function getbillinfoexport(formdata){
  let requestQuery = formdata;
  return axios({
    method: "post",
    url: `${apiUrl}/api/getbillinfoexport`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}


function deleterds(id){
  return axios({
    method: "get",
    url: `${apiUrl}/api/deleterds?id=${id}`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}


function showreportanalysis({formdataobj,pageno}){
  let requestQuery = {
    formdataobj: formdataobj,
    page: pageno
  };
  return axios({
      method: "post",
      url: `${apiUrl}/api/showreportanalysis`,
      data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
